import {
  CREATE_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_FAILURE,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  VIEW_PRODUCT,
  VIEW_PRODUCT_SUCCESS,
  VIEW_PRODUCT_FAILURE,
  UPDATE_STATUS_PRODUCT,
  UPDATE_STATUS_PRODUCT_SUCCESS,
  UPDATE_STATUS_PRODUCT_FAILURE,
  RENEWABLE_LESSON_LIST,
  RENEWABLE_LESSON_LIST_SUCCESS,
  RENEWABLE_LESSON_LIST_FAILURE,
  RENEWABLE_LESSON_TYPE_LIST,
  RENEWABLE_LESSON_TYPE_LIST_SUCCESS,
  RENEWABLE_LESSON_TYPE_LIST_FAILURE,
  RENEWABLE_LESSON_ADD_TYPE,
  RENEWABLE_LESSON_ADD_TYPE_SUCCESS,
  RENEWABLE_LESSON_ADD_TYPE_FAILURE,
  RENEWABLE_LESSON_ADD_SUB_TYPE,
  RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS,
  RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE,
  RENEWABLE_LESSON_SUBMIT,
  RENEWABLE_LESSON_SUBMIT_SUCCESS,
  RENEWABLE_LESSON_SUBMIT_FAILURE,
  GET_VIEW_LESSON,
  GET_VIEW_LESSON_SUCCESS,
  GET_VIEW_LESSON_FAILURE,
  EDIT_LESSON,
  EDIT_LESSON_SUCCESS,
  EDIT_LESSON_FAILURE,
  GET_VIEW_SUB_LESSON,
  GET_VIEW_SUB_LESSON_SUCCESS,
  GET_VIEW_SUB_LESSON_FAILURE,
  EDIT_SUB_LESSON_FAILURE,
  EDIT_SUB_LESSON_SUCCESS,
  EDIT_SUB_LESSON,
  UPDATE_LESSION_STATUS,
  UPDATE_LESSION_STATUS_SUCCESS,
  UPDATE_LESSION_STATUS_FAILURE,
  UPDATE_SUB_LESSION_STATUS,
  UPDATE_SUB_LESSION_STATUS_SUCCESS,
  UPDATE_SUB_LESSION_STATUS_FAILURE,
  GET_CURRICULUM_HEADING,
  GET_CURRICULUM_HEADING_SUCCESS,
  GET_CURRICULUM_HEADING_FAILURE,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES_SUCCESS,
  DELETE_PARTICULAR_PRODUCT,
  DELETE_PARTICULAR_PRODUCT_FAILURE,
  DELETE_PARTICULAR_PRODUCT_SUCCESS
} from "../types";

export const createProduct = (payload) => ({
  type: CREATE_PRODUCT,
  payload,
});

export const createProductSuccess = (payload) => ({
  type: CREATE_PRODUCT_SUCCESS,
  payload,
});

export const createProductFailure = (payload) => ({
  type: CREATE_PRODUCT_FAILURE,
  payload,
});

export const getProductList = (payload) => ({
  type: GET_PRODUCT_LIST,
  payload,
});

export const getProductListSuccess = (payload) => ({
  type: GET_PRODUCT_LIST_SUCCESS,
  payload,
});

export const getProductListFailure = (payload) => ({
  type: GET_PRODUCT_LIST_FAILURE,
  payload,
});

export const updateProduct = (payload) => ({
  type: UPDATE_PRODUCT,
  payload,
});

export const updateProductSuccess = (payload) => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload,
});

export const updateProductFailure = (payload) => ({
  type: UPDATE_PRODUCT_FAILURE,
  payload,
});

export const updateStatusProduct = (payload) => ({
  type: UPDATE_STATUS_PRODUCT,
  payload,
});

export const updateStatusProductSuccess = (payload) => ({
  type: UPDATE_STATUS_PRODUCT_SUCCESS,
  payload,
});

export const updateStatusProductFailure = (payload) => ({
  type: UPDATE_STATUS_PRODUCT_FAILURE,
  payload,
});

export const viewProduct = (payload) => ({
  type: VIEW_PRODUCT,
  payload,
});

export const viewProductSuccess = (payload) => ({
  type: VIEW_PRODUCT_SUCCESS,
  payload,
});

export const viewProductFailure = (payload) => ({
  type: VIEW_PRODUCT_FAILURE,
  payload,
});

export const getRenewableLessonData = (payload) => ({
  type: RENEWABLE_LESSON_LIST,
  payload,
});

export const getRenewableListSuccess = (payload) => ({
  type: RENEWABLE_LESSON_LIST_SUCCESS,
  payload,
});

export const getRenewableFailure = (payload) => ({
  type: RENEWABLE_LESSON_LIST_FAILURE,
  payload,
});

export const getRenewableLessonTypeData = (payload) => ({
  type: RENEWABLE_LESSON_TYPE_LIST,
  payload,
});

export const getRenewableLessonTypeSuccess = (payload) => ({
  type: RENEWABLE_LESSON_TYPE_LIST_SUCCESS,
  payload,
});

export const getRenewableLessonTypeFailure = (payload) => ({
  type: RENEWABLE_LESSON_TYPE_LIST_FAILURE,
  payload,
});

// add renewable lesson type

export const getRenewableLessonTypeProductValue = (payload) => ({
  type: RENEWABLE_LESSON_ADD_TYPE,
  payload,
});

export const getRenewableLessonTypeProductValueSuccess = (payload) => ({
  type: RENEWABLE_LESSON_ADD_TYPE_SUCCESS,
  payload,
});

export const getRenewableLessonTypeProductValuefailure = (payload) => ({
  type: RENEWABLE_LESSON_ADD_TYPE_FAILURE,
  payload,
});

// add renewable sub lesson type
export const getRenewableSubLessonTypeProductValue = (payload) => ({
  type: RENEWABLE_LESSON_ADD_SUB_TYPE,
  payload,
});

export const getRenewableSubLessonTypeProductValueSuccess = (payload) => ({
  type: RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS,
  payload,
});

export const getRenewablesubLessonTypeProductValuefailure = (payload) => ({
  type: RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE,
  payload,
});

// submit renewable product data
export const submitrenewableproduct = (payload) => ({
  type: RENEWABLE_LESSON_SUBMIT,
  payload,
});

export const submitrenewableproductSuccess = (payload) => ({
  type: RENEWABLE_LESSON_SUBMIT_SUCCESS,
  payload,
});

export const submitrenewableproductFailure = (payload) => ({
  type: RENEWABLE_LESSON_SUBMIT_FAILURE,
  payload,
});

// view lession

export const viewlession = (payload) => ({
  type: GET_VIEW_LESSON,
  payload,
});

export const viewlessionSuccess = (payload) => ({
  type: GET_VIEW_LESSON_SUCCESS,
  payload,
});

export const viewlessionFailure = (payload) => ({
  type: GET_VIEW_LESSON_FAILURE,
  payload,
});

// edit lession
export const editlession = (payload) => ({
  type: EDIT_LESSON,
  payload,
});

export const editlessionSuccess = (payload) => ({
  type: EDIT_LESSON_SUCCESS,
  payload,
});

export const editlessionFailure = (payload) => ({
  type: EDIT_LESSON_FAILURE,
  payload,
});

// view sub lession
export const viewsublession = (payload) => ({
  type: GET_VIEW_SUB_LESSON,
  payload,
});

export const viewsublessionsuccess = (payload) => ({
  type: GET_VIEW_SUB_LESSON_SUCCESS,
  payload,
});

export const viewsublessionfailure = (payload) => ({
  type: GET_VIEW_SUB_LESSON_FAILURE,
  payload,
});

// edit sub lession
export const editsublession = (payload) => ({
  type: EDIT_SUB_LESSON,
  payload,
});

export const editsublessionsuccess = (payload) => ({
  type: EDIT_SUB_LESSON_SUCCESS,
  payload,
});

export const editsublessionfailure = (payload) => ({
  type: EDIT_SUB_LESSON_FAILURE,
  payload,
});

// update status of lession
export const updatelessionstatus = (payload) => ({
  type: UPDATE_LESSION_STATUS,
  payload,
});

export const updatelessionstatussuccess = (payload) => ({
  type: UPDATE_LESSION_STATUS_SUCCESS,
  payload,
});

export const updatelessionstatusfailure = (payload) => ({
  type: UPDATE_LESSION_STATUS_FAILURE,
  payload,
});

// update sublession status
export const updatesublessionstatus = (payload) => ({
  type: UPDATE_SUB_LESSION_STATUS,
  payload,
});

export const updatesublessionstatussuccess = (payload) => ({
  type: UPDATE_SUB_LESSION_STATUS_SUCCESS,
  payload,
});

export const updatesublessionstatusfailure = (payload) => ({
  type: UPDATE_SUB_LESSION_STATUS_FAILURE,
  payload,
});

// get heading for curriculam

export const getCurriculumheading = (payload) => ({
  type: GET_CURRICULUM_HEADING,
  payload,
});

export const getCurriculumheadingsuccess = (payload) => ({
  type: GET_CURRICULUM_HEADING_SUCCESS,
  payload,
});

export const getCurriculumheadingfailure = (payload) => ({
  type: GET_CURRICULUM_HEADING_FAILURE,
  payload,
});

export const deleteproduct = (payload) => ({
  type: DELETE_PRODUCT,
  payload,
});

export const deleteproductsuccess = (payload) => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload,
});

export const deleteproductfailure = (payload) => ({
  type: DELETE_PRODUCT_FAILURE,
  payload,
});

export const getCategory = (payload) => ({
  type: GET_CATEGORIES,
  payload,
});

export const getcategorysuccess = (payload) => ({
  type: GET_CATEGORIES_SUCCESS,
  payload,
});

export const getcategoryfailure = (payload) => ({
  type: GET_CATEGORIES_FAILURE,
  payload,
});

export const deletePerticularSubLession = (payload) => ({
  type: DELETE_PARTICULAR_PRODUCT,
  payload,
});

export const deletePerticularSubLessionsuccess = (payload) => ({
  type: DELETE_PARTICULAR_PRODUCT_SUCCESS,
  payload,
});

export const deletePerticularSubLessionfailure = (payload) => ({
  type: DELETE_PARTICULAR_PRODUCT_FAILURE,
  payload,
});